import CorisForm from "./form/CorisForm";
import MoovForm from "./form/MoovForm";
import OrangeForm from "./form/OrangeForm";
import TelecelForm from "./form/TelecelForm";

const PaymentForm = ({ walletName }) => {
  const renderForm = {
    ORANGE_MONEY: <OrangeForm />,
    MOOV_MONEY: <MoovForm />,
    CORIS_MONEY: <CorisForm />,
    TELECEL_MONEY: <TelecelForm />
  };
  return <div>{renderForm[walletName]}</div>;
};

export default PaymentForm;
